import { render, staticRenderFns } from "./PerformanceMarketingInfoCard.vue?vue&type=template&id=37892e87"
import script from "./PerformanceMarketingInfoCard.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports